import React from 'react';
import TermsHeader from '../components/terms/TermsHeader';
import TermsIntro from '../components/terms/TermsIntro';
import TermsIndex from '../components/terms/TermsIndex';
import TermsSection from '../components/terms/TermsSection';
import TermsCTA from '../components/terms/TermsCTA';

const TermsConditions = () => {
  const handleNavigate = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      const button = element.querySelector('.section-header');
      if (button && !element.classList.contains('open')) {
        button.click();
      }
    }
  };

  return (
    <section className="bg-fondo-claro" style={{ minHeight: 'calc(100vh - 120px)' }}>
      <TermsHeader />

      <div className="mx-auto max-w-[1000px] px-5 py-[60px]">
        <TermsIntro />

        {/* Aviso importante */}
        <div className="flex items-start gap-5 bg-amber-50 border-l-[5px] border-amber-400 p-6 rounded-2xl my-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 text-amber-700"
            style={{ width: '30px', height: '30px', marginTop: '2px' }}
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <p className="text-texto-oscuro m-0 text-[1.05rem] leading-[1.7]">
            <strong>Importante:</strong> El desacato a los 'Términos y condiciones de uso' generará
            el derecho a favor del ICETEX de suspender o terminar la prestación del servicio al
            'usuario' que incurra en las faltas por acción u omisión.
          </p>
        </div>

        <TermsIndex onNavigate={handleNavigate} />

        <div className="flex flex-col gap-5 mb-[50px]">
          <TermsSection
            id="servicio"
            title="El Servicio y la Información"
            defaultOpen={true}
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
            }
          >
            <p>
              El servicio que ofrece el Portal del ICETEX tiene por finalidad brindar al 'usuario'
              información relacionada con los servicios que presta este Instituto.
            </p>
            <p>
              La prestación del servicio del Portal por parte del ICETEX es de carácter libre y
              gratuito para los 'usuarios'; no obstante, la utilización de algunos servicios sólo
              puede hacerse como 'usuario registrado' sin que esto signifique incurrir en un costo
              monetario.
            </p>
          </TermsSection>

          <TermsSection
            id="registro"
            title="Registro"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            }
          >
            <p>
              Efectuar la labor de registro no es necesario en todos los casos, sin embargo, sí es
              una acción imprescindible al utilizar el servicio de impresión del recibo de pago, al
              querer recibir atención personalizada por el Centro de Atención Virtual, al querer hacer
              uso del servicio de chat, pago en línea, algunas consultas del estado de cuenta y otros
              según el caso.
            </p>
            <p>
              Sin perjuicio de ello, en caso de que el 'usuario' elija o deba registrarse para utilizar
              algún servicio deberá completar el formulario con su información personal de manera exacta
              y precisa en la sección regístrese en cada una de estas secciones del Portal Web.
            </p>
            <p>
              La información personal como 'usuario registrado' está protegida con una clave que sólo el
              'usuario' conoce y con la que podrá tener acceso al servicio que la requiera las veces que
              necesite acceder a él.
            </p>
            <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <p>
                El 'usuario registrado' se comprometerá a notificar al ICETEX en forma inmediata y
                a través de un medio fehaciente, cualquier uso no autorizado de su clave.
              </p>
            </div>
          </TermsSection>

          <TermsSection
            id="modificacion"
            title="Modificación de Contenidos"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            }
          >
            <p>
              El Portal del ICETEX se reserva el derecho de modificar o de corregir el contenido de
              las condiciones y de este sitio web en cualquier momento y sin previo aviso a los usuarios.
            </p>
            <p>
              Todos los derechos que no son expresamente concedidos en los términos de las presentes
              disposiciones reglamentarias están reservados por el Portal del ICETEX, y por lo tanto,
              deben ser de obligatorio acatamiento.
            </p>
            <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              <p>
                <strong>Advertencia Legal:</strong> El usuario que contravenga lo reglamentado en este
                documento deberá sujetarse a las sanciones civiles y penales que establece la ley
                colombiana sobre derechos de autor en el ámbito nacional e internacional.
              </p>
            </div>
          </TermsSection>

          <TermsSection
            id="privacidad"
            title="Privacidad de la Información"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            }
          >
            <p>
              La recolección y tratamiento automatizado de los datos personales tiene como finalidad el
              buen y fluido mantenimiento de la relación establecida entre el 'usuario' y el ICETEX,
              representado en acciones como:
            </p>
            <ul>
              <li>La gestión, administración, prestación, ampliación y mejora de los servicios</li>
              <li>La adecuación de dichos servicios a las preferencias y gustos del usuario</li>
              <li>El estudio de la utilización de los servicios por parte de los usuarios</li>
              <li>El diseño de nuevos servicios relacionados</li>
              <li>El envío de actualizaciones de los servicios</li>
              <li>El envío de información técnica, operativa y comercial</li>
            </ul>
            <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              <p>
                <strong>Protección de Datos:</strong> La información no será divulgada a terceros sin
                consentimiento de quien suministre la información, salvo en los casos en que las leyes
                colombianas lo exijan.
              </p>
            </div>
          </TermsSection>

          <TermsSection
            id="propiedad"
            title="Propiedad Intelectual"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            }
          >
            <p>
              Se entenderá por 'contenidos' todas las informaciones, mensajes, gráficos, fotografías,
              dibujos, diseños, logotipos, nombres, marcas u otro tipo de archivos de audio o de imagen,
              cualquier software en general o clase de material accesible a través de los canales web
              del ICETEX.
            </p>
            <p>
              Las obras protegidas por los derechos de autor que se encuentren dentro de la página
              principal del ICETEX, hacen parte del patrimonio de la entidad pública y por lo tanto
              son considerados bienes fiscales.
            </p>
            <h4>El usuario se obliga a:</h4>
            <ul>
              <li>Usar los 'contenidos' de forma diligente, correcta y lícita</li>
              <li>No reproducir, copiar, distribuir, transformar o modificar los 'contenidos' a menos
                  de que se cuente con la autorización del titular de los correspondientes derechos</li>
              <li>No suprimir, eludir, o manipular el "copyright" y demás datos identificatorios de los
                  derechos incorporados a los 'contenidos'</li>
              <li>No emplear los 'contenidos' para emitir publicidad sin autorización</li>
            </ul>
            <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <p>
                <strong>Responsabilidad:</strong> El ICETEX no será responsable por el uso indebido que
                hagan los usuarios del contenido de sus canales Web.
              </p>
            </div>
          </TermsSection>

          <TermsSection
            id="ley"
            title="Ley Aplicable y Jurisdicción"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
            }
          >
            <p>
              Estas condiciones generales se rigen por la ley colombiana y aplican para el Portal Web
              del ICETEX y el 'usuario', con renuncia expresa a cualquier otro fuero, se someten al de
              los juzgados y tribunales competentes de la ciudad de Bogotá D.C.
            </p>
            <p>
              Los términos y condiciones sólo pueden ser modificados completa o parcialmente por el ICETEX;
              dichos cambios e implementación tendrán vigencia a partir del instante en que se publiquen
              o inserten en el sitio, o desde el momento en que el cambio sea informado al 'usuario' a
              través de cualquier medio, lo que ocurra primero.
            </p>
            <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
              <p>
                <strong>Recomendación:</strong> Se sugiere al 'usuario' que visite la sección de
                'Términos y condiciones de uso' regularmente para estar al tanto de cualquier
                actualización.
              </p>
            </div>
          </TermsSection>
        </div>

        <TermsCTA />
      </div>
    </section>
  );
};

export default TermsConditions;
